import {
	CalendarCommonModule,
	CalendarEvent,
	CalendarEventTimesChangedEvent,
	CalendarMonthModule,
	CalendarMonthViewDay,
} from 'angular-calendar';
import { Subject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarMonthDayCellComponent } from '@schedule/lib/components/calendar-month-day-cell/calendar-month-day-cell.component';
import { CalendarMonthHeadersComponent } from '@schedule/lib/components/calendar-month-headers/calendar-month-headers.component';
import { CalendarColumnHeaderClickedEvent } from '@schedule/lib/types/calendar.types';

@Component({
	selector: 'app-calendar-month-view',
	imports: [CommonModule, CalendarCommonModule, CalendarMonthModule, CalendarMonthDayCellComponent, CalendarMonthHeadersComponent],
	templateUrl: './calendar-month-view.component.html',
	styleUrl: './calendar-month-view.component.scss',
})
export class CalendarMonthViewComponent {
	@Input() events: CalendarEvent[];
	@Input() refresh: Subject<void>;
	@Input() viewDate: Date;
	@Input() activeDayIsOpen: boolean;
	@Output() dayClicked = new EventEmitter<CalendarMonthViewDay>();
	@Output() eventClicked = new EventEmitter<CalendarEvent>();
	@Output() eventTimesChanged = new EventEmitter<CalendarEventTimesChangedEvent>();
	@Output() columnHeaderClicked = new EventEmitter<CalendarColumnHeaderClickedEvent>();

	handleDayClicked(day: CalendarMonthViewDay): void {
		this.dayClicked.emit(day);
	}

	handleEventClicked(event: CalendarEvent): void {
		this.eventClicked.emit(event);
	}

	handleEventTimesChanged(event: CalendarEventTimesChangedEvent): void {
		this.eventTimesChanged.emit(event);
	}

	handleColumnHeaderClicked(event: CalendarColumnHeaderClickedEvent): void {
		this.columnHeaderClicked.emit(event);
	}
}
